export default "__VITE_ASSET__faf28b07__"